import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CsvIcon from "../../assets/CsvIcon";
import PdfIcon from "../../assets/PdfIcon";
import XlsIcon from "../../assets/XlsIcon";
import CustomTextfield from "../../components/CustomInputs/CustomTextfield";
import CancelButtons from "../../components/DialogBoxComponent/CancelButtons";
import SubmitButtons from "../../components/DialogBoxComponent/SubmitButtons";
import ExportIcon from "../../components/Icons/ExportIcon";
import ExportIconHover from "../../components/Icons/ExportIConHover";
import Toast from "../../components/ToastContainer/CustomToast";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";

export default function ExportDialog(props) {
  const [open, setOpen] = React.useState(false);
  const { t } = useTranslation();
  const [changeDate, setDateChange] = useState(true);
  const [dateOpen, setDateOpen] = useState("");
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  const [fromRecord, setFromRecord] = useState("");
  const [toRecord, setToRecord] = useState("");
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (props.noOfRecords === "1") {
      props.setInputValue("");
      props.setToInputValue("");
    }
  }, [props.noOfRecords]);

  useEffect(() => {
    if (props?.closemodel) {
      handleClose();
      props.setClosemodel(!props?.closemodel);
    }
  });

  useEffect(() => {
    props.setIsLivePhoto(false);
    props.setIsSignature(false);
  }, [props.fileFormat]);

  const formatDayAndMonth = (numValue) => {
    if (numValue <= 0) {
      return "-" + (numValue + 12);
    }
    if (numValue < 10) {
      return "-0" + numValue;
    } else {
      return "-" + numValue;
    }
  };
  var today = new Date();
  var endDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T23:59:59";
  var startDate =
    today.getFullYear() +
    formatDayAndMonth(today.getMonth() + 1) +
    formatDayAndMonth(today.getDate()) +
    "T00:00";

  const [payload, setPayload] = useState({
    scheduledStartDate: CommonUtil.formatToUtc(startDate),
    scheduledEndDate: CommonUtil.formatToUtc(endDate),
  });

  const handleClose = () => {
    setPayload({
      scheduledStartDate: CommonUtil.formatToUtc(startDate),
      scheduledEndDate: CommonUtil.formatToUtc(endDate),
    });
    setOpen(false);
    setDiaLogBoxBlur(false);
    props.setFileFormat("1");
    props.setNoOfRecords("0");
    props.setInputValue("");
    props.setToInputValue("");
    props.setIsLivePhoto(false);
    props.setIsSignature(false);
  };

  if (open) {
    setDiaLogBoxBlur(true);
  }

  const reset = () => {
    props.setFileFormat("1");
    props.setNoOfRecords("0");
    props.setInputValue("");
    props.setToInputValue("");
    props.setIsLivePhoto(false);
    props.setIsSignature(false);
    setPayload({
      scheduledStartDate: CommonUtil.formatToUtc(startDate),
      scheduledEndDate: CommonUtil.formatToUtc(endDate),
    });
    setDateOpen(props.open);
    handleClose();
  };

  const [error, setError] = useState({
    scheduledStartDate: false,
    scheduledEndDate: false,
  });

  const handleSubmit = () => {
    if (
      payload.scheduledStartDate === null &&
      payload.scheduledEndDate === null
    ) {
      Toast(t("COMMON015"), "error");
      return;
    }

    if (
      props?.noOfRecords === "1" &&
      CommonUtil.isEmptyString(props?.inputValue)
    ) {
      setError(true);
      Toast(t("From is required."), "error");
      return;
    }
    if (
      props?.noOfRecords === "1" &&
      CommonUtil.isEmptyString(props?.toInputValue)
    ) {
      setError(true);
      Toast(t("To is required."), "error");
      return;
    }
    if (Number(props?.toInputValue) < Number(props?.inputValue)) {
      setError(true);
      Toast(
        t(
          "Your selection range is invalid. The starting row must be less than or equal to the ending row.",
        ),
        "error",
      );
      return;
    }

    if (props?.inputValue && props?.toInputValue > props?.totalRecords) {
      setError(true);
      Toast(
        t(
          "Custom Values must be within the range of total records 1 to  " +
            props?.totalRecords,
        ),
        "error",
      );
      return;
    }

    if (
      props.totalRecords === undefined ||
      props.totalRecords === null ||
      props.totalRecords == 0
    ) {
      setError(true);
      Toast(t("No Records Found"), "error");
      return;
    }

    if (
      payload.scheduledStartDate === null ||
      payload.scheduledStartDate === undefined ||
      payload.scheduledStartDate === ""
    ) {
      setError({ scheduledStartDate: true });
      Toast(t("INVITESTARTDATEERROR"), "error");
      return;
    }

    if (
      payload.scheduledEndDate === null ||
      payload.scheduledEndDate === undefined ||
      payload.scheduledEndDate === ""
    ) {
      setError({ scheduledEndDate: true });
      Toast(t("INVITEENDDATEERROR"), "error");
      return;
    }

    if (
      new Date(payload.scheduledStartDate).toString() === "Invalid Date" ||
      new Date(payload.scheduledEndDate).toString() === "Invalid Date"
    ) {
      Toast(t("USERPROFSCREEN013"), "error");
      return;
    }

    if (
      new Date(payload.scheduledEndDate) < new Date(payload.scheduledStartDate)
    ) {
      Toast(t("INVITATIONFORM010"), "error");
      return;
    }
    // handleClose();
    props.applyFilter(payload);
    setPayload({
      scheduledStartDate: CommonUtil.formatToUtc(startDate),
      scheduledEndDate: CommonUtil.formatToUtc(endDate),
    });
  };
  return (
    <div sx={{ overflow: "hidden", "& .MuiDialog-paper": { with: "100px" } }}>
      <Tooltip title={<Typography>{t("EMP014")}</Typography>}>
        <Box
          className={darkMode ? "exportIcondark" : "exportIcon"}
          onClick={() => setOpen(!open)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {isHovered ? <ExportIconHover /> : <ExportIcon />}
        </Box>{" "}
      </Tooltip>

      <Dialog
        open={open}
        fullWidth={false}
        maxWidth={false}
        disableBackdropClick
        disableEscapeKeyDown
        BackdropProps={{
          style: {
            backdropFilter: "blur(5px)",
          },
        }}
        sx={{
          "& .MuiDialog-paper": {
            width: "700px",
            maxWidth: "100%",
            marginLeft: "100px",
          },
          overflow: "hidden",
          maxHeight: "180vh",
          minWidth: "100px",
          boxShadow: "10px 10px 10px #00000029",
          backdropFilter: "blur(5px)",

          // zIndex: 10001,
        }}
      >
        <DialogTitle
          variant="h4"
          style={{ backgroundColor: darkMode ? "#0E2A41" : "#fff" }}
        >
          <Typography
            style={{ fontSize: "21px", color: darkMode ? "#fff" : "black" }}
          >
            {t("EMP014")}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 15,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        {/* <Divider variant="middle" /> */}
        <DialogContent
          style={{
            padding: "1px 28.5px 5px 24.5px",
            overflow: "hidden",
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
          }}
        >
          <Grid
            container
            spacing={2}
            style={{ marginLeft: "0px", overflow: "hidden" }}
          >
            <Typography
              style={{
                fontSize: "16px",
                font: "normal normal medium 16px/19px Roboto",
                letterSpacing: "0px",
                color: darkMode ? "white" : "#161515",
                opacity: 1,
                marginTop: "15px",
                marginBottom: "5px",
              }}
              variant="h6"
            >
              {props?.nameTitle}
            </Typography>

            <Grid
              item
              xs={12}
              style={{
                backgroundColor: darkMode ? "#1B3F60" : "#F2F2F2",
                marginBottom: "10px",
                marginRight: "13px",
                height: "75px",
                width: "500px",
              }}
            >
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  name="fileFormat"
                  value={props?.fileFormat}
                  onChange={props?.handleFileFormatChange}
                >
                  <Grid
                    item
                    sm={3}
                    style={{
                      backgroundColor: darkMode ? "#274968" : "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "10px",
                      width: "600px",
                      height: "44px",
                      // opacity: darkMode ? '0.05' : '',
                      borderRadius: "2px",
                    }}
                  >
                    <FormControlLabel
                      value="1"
                      // style={{ marginLeft: '20px' }}
                      sx={{
                        "& .css-1hbvpl3-MuiSvgIcon-root": {
                          color:
                            props?.fileFormat === "1"
                              ? "#F2824C"
                              : darkMode
                              ? "white"
                              : "",
                        },
                        marginLeft: "10px",
                        marginTop: "4px",
                      }}
                      control={
                        <Radio
                          style={{
                            color: props?.fileFormat === "1" ? "#F2824C" : "",
                            marginTop: "4px",
                          }}
                        />
                      }
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            // marginLeft: '10px',
                            // color: '#242424'
                            marginTop: "4px",
                          }}
                        >
                          <XlsIcon />
                          <span
                            style={{
                              marginLeft: "17px",
                              fontSize: "16px",
                              color: darkMode ? "white" : "",
                            }}
                          >
                            XLS
                          </span>
                        </div>
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    sm={3}
                    style={{
                      backgroundColor: darkMode ? "#274968" : "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "18px",
                      width: "720px",
                      height: "44px",
                    }}
                  >
                    <FormControlLabel
                      value="0"
                      // style={{ marginLeft: '20px' }}
                      sx={{
                        "& .css-1hbvpl3-MuiSvgIcon-root": {
                          color:
                            props?.fileFormat === "0"
                              ? "#F2824C"
                              : darkMode
                              ? "white"
                              : "",
                        },
                        marginLeft: "20px",
                        marginTop: "4px",
                      }}
                      control={
                        <Radio
                          style={{
                            color: props?.fileFormat === "0" ? "#F2824C" : "",
                            marginTop: "4px",
                          }}
                        />
                      }
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "10px",
                            color: "#242424",
                            marginTop: "4px",
                          }}
                        >
                          <PdfIcon />
                          <span
                            style={{
                              marginLeft: "17px",
                              fontSize: "16px",
                              color: darkMode ? "white" : "",
                            }}
                          >
                            PDF
                          </span>
                        </div>
                      }
                    />
                  </Grid>
                  <Grid
                    item
                    sm={3}
                    style={{
                      backgroundColor: darkMode ? "#274968" : "#FFFFFF",
                      display: "flex",
                      alignItems: "center",
                      marginLeft: "18px",
                      width: "720px",
                      height: "44px",
                    }}
                  >
                    <FormControlLabel
                      value="2"
                      // style={{ marginLeft: '20px' }}
                      sx={{
                        "& .css-1hbvpl3-MuiSvgIcon-root": {
                          color:
                            props?.fileFormat === "2"
                              ? "#F2824C"
                              : darkMode
                              ? "white"
                              : "",
                        },
                        marginLeft: "20px",
                        marginTop: "4px",
                      }}
                      control={
                        <Radio
                          style={{
                            color: props?.fileFormat === "2" ? "#F2824C" : "",
                            marginTop: "4px",
                          }}
                        />
                      }
                      label={
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            marginLeft: "10px",
                            color: "#242424",
                            marginTop: "4px",
                          }}
                        >
                          <CsvIcon />
                          <span
                            style={{
                              marginLeft: "17px",
                              fontSize: "16px",
                              color: darkMode ? "white" : "",
                            }}
                          >
                            CSV
                          </span>
                        </div>
                      }
                    />
                  </Grid>
                </RadioGroup>
              </FormControl>
            </Grid>

            {/* Data to Export */}
            <Typography
              style={{
                fontSize: "16px",
                font: "normal normal medium 16px/19px Roboto",
                letterSpacing: "0px",
                color: darkMode ? "white" : "#161515",
                opacity: 1,
                marginTop: "10px",
                marginBottom: "5px",
              }}
              variant="h6"
            >
              {t("Data to Export")}
            </Typography>
            <Grid
              item
              xs={12}
              style={{
                backgroundColor: darkMode ? "#1B3F60" : "#F2F2F2",
                marginRight: "13px",
              }}
            >
              <RadioGroup
                style={{ marginLeft: "0px" }}
                name="fileFormat"
                value={props?.noOfRecords}
                onChange={props?.handleDataRecordsChange}
              >
                <Grid>
                  <FormControlLabel
                    value="0"
                    sx={{
                      "& .css-1hbvpl3-MuiSvgIcon-root": {
                        color:
                          props?.noOfRecords === "0"
                            ? "#F2824C"
                            : darkMode
                            ? "white"
                            : "",
                      },
                      marginLeft: "20px",
                    }}
                    control={
                      <Radio
                        style={{
                          color: props?.noOfRecords === "0" ? "#F2824C" : "",
                        }}
                      />
                    }
                    label={
                      <div
                        style={{
                          font: "normal normal normal 16px/21px Roboto",
                          letterSpacing: "0px",
                          color: darkMode ? "white" : "#5A5A5A",
                          opacity: 1,
                        }}
                      >
                        {t("All (max 10000 records)")}
                      </div>
                    }
                  />
                </Grid>
                <Grid
                  sx={{
                    paddingBottom:
                      props?.dealerPortal || props?.fileFormat === "2"
                        ? "10px"
                        : "0px",
                  }}
                >
                  {" "}
                  <FormControlLabel
                    value="1"
                    sx={{
                      "& .css-1hbvpl3-MuiSvgIcon-root": {
                        color:
                          props?.noOfRecords === "1"
                            ? "#F2824C"
                            : darkMode
                            ? "white"
                            : "",
                      },
                      marginLeft: "20px",
                    }}
                    control={
                      <Radio
                        style={{
                          color: props?.noOfRecords === "1" ? "#F2824C" : "",
                        }}
                      />
                    }
                    label={
                      <div
                        style={{
                          font: "normal normal normal 16px/21px Roboto",
                          letterSpacing: "0px",
                          color: darkMode ? "white" : "#5A5A5A",
                          opacity: 1,
                        }}
                      >
                        {t("Custom (max 10000 records)")}
                      </div>
                    }
                  />
                </Grid>
              </RadioGroup>

              {props?.noOfRecords === "1" ? (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ marginLeft: "15px", paddingBottom: "10px" }}
                >
                  <Grid item lg={4} sm={6}>
                    <CustomTextfield
                      label={t("From")}
                      name="inputValue"
                      value={props?.inputValue}
                      required={true}
                      handleChange={props?.handleInputChange}
                      autoComplete="off"
                      InputProps={{
                        style: {
                          color: darkMode ? "#fff" : "black",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item lg={4} sm={6}>
                    <CustomTextfield
                      label={t("To")}
                      name="toInputValue"
                      value={props?.toInputValue}
                      required={true}
                      handleChange={props?.handleToInputChange}
                      autoComplete="off"
                      InputProps={{
                        style: {
                          color: darkMode ? "#fff" : "black",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              ) : null}
              {!props?.dealerPortal && props?.fileFormat !== "2" ? (
                <Grid
                  xs={12}
                  style={{
                    marginLeft: "19px",
                    display: "flex",
                    alignItems: "center",
                    paddingBottom: "14px",
                  }}
                >
                  <Stack direction="row">
                    <Checkbox
                      sx={{
                        "& .MuiSvgIcon-root": {
                          color: darkMode ? "#fff" : "#5A5A5A", // Default color (unchecked)
                        },
                        "&.Mui-checked .MuiSvgIcon-root": {
                          color: "rgb(242, 130, 76)", // Checked color
                        },
                      }}
                      checked={props.isLivePhoto}
                      onChange={props.handleCheckBoxLivePhoto}
                    />
                    <div
                      style={{
                        font: "normal normal normal 16px/21px Roboto",
                        letterSpacing: "0px",
                        color: darkMode ? "white" : "#5A5A5A",
                        opacity: 1,
                        alignContent: "center",
                      }}
                    >
                      {t("Live photo")}
                    </div>
                  </Stack>
                  {!props.onlyLivePhoto ? (
                    <Stack direction="row">
                      <Checkbox
                        sx={{
                          "& .MuiSvgIcon-root": {
                            color: darkMode ? "#fff" : "#5A5A5A", // Default color (unchecked)
                          },
                          "&.Mui-checked .MuiSvgIcon-root": {
                            color: "rgb(242, 130, 76)", // Checked color
                          },
                        }}
                        checked={props.isSignature}
                        onChange={props.handleCheckBoxSignature}
                      />
                      {/* <Typography style={{alignContent : 'center' , color : darkMode ? 'white' : ""}}>{t("Signature")}</Typography> */}
                      <div
                        style={{
                          font: "normal normal normal 16px/21px Roboto",
                          letterSpacing: "0px",
                          color: darkMode ? "white" : "#5A5A5A",
                          opacity: 1,
                          alignContent: "center",
                        }}
                      >
                        {t("Signature")}
                      </div>
                    </Stack>
                  ) : null}
                </Grid>
              ) : null}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{
            justifyContent: "center",
            backgroundColor: darkMode ? "#0E2A41" : "#fff",
            marginBottom: "3px",
          }}
        >
          <CancelButtons variant="contained" color="secondary" onClick={reset}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("INVITATION003")}
            </Typography>
          </CancelButtons>
          <SubmitButtons variant="contained" onClick={handleSubmit}>
            <Typography variant="body1" style={{ textTransform: "none" }}>
              {t("COMMON024")}
            </Typography>
          </SubmitButtons>
        </DialogActions>
      </Dialog>
    </div>
  );
}
